import * as types from '../mutation-types'
import * as consts from '../../../modules/data/base/consts'
import { API } from '../../../modules/api';
import { UTILS } from '../../../modules/utils';
import { USER_DATA_MANAGER } from '../../../modules/data'

export default {
    namespaced: true,
    state: {
		inputData: {
			gender: -1,
			birthday: 0,
		},
		// nickname: '',
		userBaseInfo: {},
		userEvent: [],
		userTips: '',
		userBaseTalentIndicator: [],
		userBaseTalentValue: [],
		userShowDiscountPop: false,
		userShowFreePop: false,
		userRecordList: [],
		isNewCreated: false,
		gotUserPageData: false,
		userPageData: {},
		reportFData: {},
		reportFPayData: {},
		reportFMonthList: [],
		reportFMCategories: [],
		reportFMSeries: [],
		reportSData: {},
		reportSPayData: {},
		reportSMonthList: [],
		reportSMCategories: [],
		reportSMSeries: [],
		reportShowTip: true,
		reportShowSuccess: false,
		reportShowBefore: false,
		reportShowAbout: false,
		reportShowShare: false
    },
    mutations: {},
    actions: {
        addUser({dispatch, state}, params) {
			// console.error('addUser------', state.inputData)
			API.addUser({
				birthday: state.inputData.birthday,
				f_name: state.inputData.nickname,
				gender: state.inputData.gender
			}, function(data) {
				console.log('添加测算成功:::::::', data);
				state.isNewCreated = true;
				state.userBaseInfo = Object.assign({}, data.info);
				state.userEvent = [].concat(data.event);
				state.userTips = data.tips;
				var resultData = USER_DATA_MANAGER.getUserBaseTalentInfoByData(data.talent);
				state.userBaseTalentIndicator = resultData.categories;
				state.userBaseTalentValue = resultData.series;
				// 增加数据到列表中
				// dispatch('addMyUserListData', data.info, {root: true});
				if(params && params.cb && typeof(params.cb) == 'function') {
					params.cb(data.info);
				}
			})
		},
		getUserRecordList({state}, params) {
			API.getReportList({}, function(data) {
				console.log('获取测算列表成功:::::::', data)
				state.userRecordList = [].concat(data);
			})
		},
		getUserHomePageData({dispatch, state}, params) {
			API.getUserHomePage({
				id: params && params.id ? params.id : (state.userBaseInfo && state.userBaseInfo.id ? state.userBaseInfo.id : 0)
			}, function(data) {
				console.log(' :::::::', data, state.inputData)
				state.gotUserPageData = true;
				var resultData = USER_DATA_MANAGER.getHomePageDataByData(data);
				state.userPageData = Object.assign({
					fName: state.inputData.nickname ? state.inputData.nickname : params.rData ? params.rData.f_name : ''
				}, resultData);
				state.reportFData = Object.assign({}, resultData.f);
				state.reportFPayData = Object.assign({}, resultData.f.pay);
				state.reportFMonthList = [].concat(resultData.fMonthList);
				state.reportFMCategories = [].concat(resultData.fMCategories);
				state.reportFMSeries = [].concat(resultData.fMSeries);
				state.reportSData = Object.assign({}, resultData.s);
				state.reportSPayData = Object.assign({}, resultData.s.pay);
				state.reportSMonthList = [].concat(resultData.sMonthList);
				state.reportSMCategories = [].concat(resultData.sMCategories);
				state.reportSMSeries = [].concat(resultData.sMSeries);
				if(params && params.cb && typeof(params.cb) == 'function') {
					params.cb();
				}
				console.log('reportFMCategories----', state.reportFMCategories, state.reportFMSeries)
				// console.error('getUserHomePageData-----', data)
			}, function(data) {
				if(params && params.failCb && typeof(params.failCb) == 'function') {
					params.failCb();
				}
			})
		},
		freeLockMyReport({state}, params) {
			// console.error('freeLockMyReport-----', params)
			API.freeLock({
				id: params.params.id.toString(),
				pid: params.params.pid
			}, function(data) {
				console.log('免费解锁成功:::::::', data)
				if(params && params.sucCb && typeof(params.sucCb) == 'function') {
					params.sucCb();
				}
			}, function(data) {
				console.error('免费解锁失败:::::::', data)
				if(params && params.failCb && typeof(params.failCb) == 'function') {
					params.failCb();
				}
			})
		},
		resetUserInputData({state}) {
			state.inputData = {
				gender: -1,
				nickname: '',
				birthday: 0,
			};
		},
        resetData({state}) {
            state.userBaseInfo = {};
            state.inputData = {
				gender: -1,
				nickname: '',
				birthday: 0,
            };
        }
    }
}
